import { defineComponent as d, computed as a, createBlock as n, openBlock as u, unref as m, normalizeClass as i } from "vue";
import * as c from "../../assets/flags/index.js";
import { RevIllustration as f } from "@ds/components/Illustration";
import { tw as e } from "../../utils/tailwind.js";
const h = /* @__PURE__ */ d({
  __name: "CountryFlag",
  props: {
    countryCode: {},
    size: { default: "medium" },
    hasBorder: { type: Boolean, default: !1 }
  },
  setup(s) {
    const t = a(() => ({
      "extra-small": e`w-12`,
      small: e`w-18`,
      medium: e`w-24`,
      large: e`w-[1.875rem]`,
      "extra-large": e`w-36`
    })[s.size]), o = a(() => `border-static-default-dim border-[0.5px] ${{
      "extra-small": "rounded-[0.67px]",
      small: "rounded-[1px]",
      medium: "rounded-[1.33px]",
      large: "rounded-[1.67px]",
      "extra-large": "rounded-xs"
    }[s.size]}`), l = a(() => c[`${s.countryCode}`]);
    return (r, p) => (u(), n(m(f), {
      alt: r.countryCode,
      class: i([t.value, { [o.value]: r.hasBorder }]),
      height: 16,
      src: l.value,
      width: 24
    }, null, 8, ["alt", "class", "src"]));
  }
});
export {
  h as default
};
